import { formatDate } from '@angular/common';
import { ElementTypeGuidEnum } from 'projects/phdsoft/common/src/lib/models/guid-enum';
import { CreationCommandTypes, ExecutionStatus } from 'src/app/platform/busines-data/DomainEntity';
import { MaterialType } from 'src/app/platform/busines-data/ResourceElements/MaterialType';
import { StructuralElement } from 'src/app/platform/busines-data/SectionElements/StructureElements/StructuralElement';
import { WorkableElement } from 'src/app/platform/busines-data/SectionElements/WorkableElement';
import {
  BracketStructureAssessmentProperties, CableStructureAssessmentProperties, ElementPropertiesVisualizationMode, FacePlateStructureAssessmentProperties,
  GeneralProperties, MaterialProperties, PipeStructureAssessmentProperties, PlateStructureAssessmentProperties,
  SolidBeamPartStructureAssessmentProperties,
  StiffenerStructureAssessmentProperties, StructureAssessmentProperties, SurfaceBeamPartStructureAssessmentProperties,
  TypicalDetailsProperties
} from '../models/element-properties.model';
import { ELEMENTSTYPESIDS, Util } from '@phdsoft/common';
import { LinearElement } from '@app/platform/busines-data/SectionElements/StructureElements/LinearElement';
import * as THREE from 'three';
export class ElementPropertiesMapper {

  public static MapToVisualizationMode(element: StructuralElement,
    regionsData: any, sectionData: any, isDegradationModeOpen?: boolean, showComputeDimensions?: boolean): ElementPropertiesVisualizationMode {
    // if (element.CreationCommandType === 'RepairElement')
    //   return {
    //     Id: element.properties.General?.ElementId,
    //     General: ElementPropertiesMapper.MapGeneralProperties(element.properties),
    //     Material: ElementPropertiesMapper.MapMaterialProperties(element.MaterialType),
    //     StructureAssessment: ElementPropertiesMapper.MapStructureAssessmentProperties(element.properties),
    //     RepairInfo: ElementPropertiesMapper.MapStructureAssessmentProperties(element.properties),
    //     RegionsCapacity: ElementPropertiesMapper.MapRegionsCapacityProperties(regionsData, sectionData)
    //   }
    // else {
    // if (isDegradationModeOpen)
    //   return {
    //     Id: element.properties?.General?.ElementId,
    //     General: ElementPropertiesMapper.MapGeneralProperties(element.properties, element.isExecuted),
    //     Material: ElementPropertiesMapper.MapMaterialProperties(element.MaterialType),
    //     StructureAssessment: ElementPropertiesMapper.MapStructureAssessmentProperties(element.properties),
    //     RegionsCapacity: ElementPropertiesMapper.MapRegionsCapacityProperties(regionsData, sectionData),
    //     Degradation: ElementPropertiesMapper.MapDegradationProperties(element)
    //   }
    let dimensions = null;

    if(showComputeDimensions){
      switch (element.TypeId) {
        case ELEMENTSTYPESIDS.PLATE:
          dimensions =  Math.trunc(element.Height) + " x " + Math.trunc(element.Width) + " x " + element.thickness;
          break;
        case ELEMENTSTYPESIDS.STIFFENER:

          let height = element.properties.Geometry.WebHeight != null && element.properties.Geometry.WebHeight > 0 ? 
          element.properties.Geometry.WebHeight : (element as LinearElement).completeIdElements.find(x => x.properties.Geometry.WebHeight)?.properties.Geometry.WebHeight;
          let width = element.properties.Geometry.FlangeWidth != null && element.properties.Geometry.FlangeWidth > 0 ? 
          element.properties.Geometry.FlangeWidth : (element as LinearElement).completeIdElements.find(x => x.properties.Geometry.FlangeWidth)?.properties.Geometry.FlangeWidth;

          if(!Number.isNaN(height) && height > 0 && !Number.isNaN(width) && width > 0)
          {
            let finalHeight = Math.trunc(height);
            if(finalHeight <= 10 || finalHeight === 1){
              finalHeight = Math.trunc(height *1000);
            }

            let finalWidth = Math.trunc(width);
            if(finalWidth <= 10 || finalWidth === 1){
              finalWidth = Math.trunc(width *1000);
            }

            dimensions =  finalHeight + " x " + finalWidth + " x " + element.thickness;

          }
          else if(!Number.isNaN(height) && height > 0)
          {
            let finalHeight = Math.trunc(height);
            if(finalHeight <= 10 || finalHeight === 1){
              finalHeight = Math.trunc(height *100);
            }

            dimensions =  finalHeight + " x "  + element.thickness;
          }
          break;
        case ELEMENTSTYPESIDS.BRACKET:

          let height1 = element.properties.Geometry.MajorWebHeight != null && element.properties.Geometry.MajorWebHeight > 0 ? 
          element.properties.Geometry.MajorWebHeight : (element as LinearElement).completeIdElements.find(x => x.properties.Geometry.MajorWebHeight)?.properties.Geometry.MajorWebHeight;

          let height2 = element.properties.Geometry.MajorWebWidth != null && element.properties.Geometry.MajorWebWidth > 0 ? 
          element.properties.Geometry.MajorWebWidth : (element as LinearElement).completeIdElements.find(x => x.properties.Geometry.MajorWebWidth)?.properties.Geometry.MajorWebWidth;
          
          let widthFlange = element.properties.Geometry.FlangeWidth != null && element.properties.Geometry.FlangeWidth > 0 ? 
          element.properties.Geometry.FlangeWidth : (element as LinearElement).completeIdElements.find(x => x.properties.Geometry.FlangeWidth)?.properties.Geometry.FlangeWidth;
          
          if(height1 > height2) {

            let finalHeight1 = Math.trunc(height1);
            if(finalHeight1 <= 10 || finalHeight1 === 1){
              finalHeight1 = Math.trunc(height1 *1000);
            }

            let finalHeight2 = Math.trunc(height2);
            if(finalHeight2 <= 10 || finalHeight2 === 1){
              finalHeight2 = Math.trunc(height2 *1000);
            }

            let finalWidthFlange = Math.trunc(widthFlange);
            if(finalWidthFlange <= 10 || finalWidthFlange === 1){
              finalWidthFlange = Math.trunc(widthFlange *1000);
            }

            dimensions =  finalHeight1 + " x " + finalHeight2 + " x " + finalWidthFlange + " x " + element.thickness;
          }
          else{
            let finalHeight2 = Math.trunc(height2);
            if(finalHeight2 <= 10 || finalHeight2 === 1){
              finalHeight2 = Math.trunc(height2 *1000);
            }

            let finalHeight1 = Math.trunc(height1); 
            if(finalHeight1 <= 10 || finalHeight1 === 1){
              finalHeight1 = Math.trunc(height1 *1000);
            }

            let finalWidthFlange = Math.trunc(widthFlange); 
            if(finalWidthFlange <= 10 || finalWidthFlange === 1){
              finalWidthFlange = Math.trunc(widthFlange *1000);
            }

            dimensions =  finalHeight2 + " x " + finalHeight1 + " x " + finalWidthFlange + " x " + element.thickness;
          }
          break;
        case ELEMENTSTYPESIDS.FACEPLATE:
          // if(Util.LargestCanonicalAxisDirection(element.sectionNormal.clone()) === 'x'){
          let size: THREE.Vector3 = new THREE.Vector3();
          size = element.SurfaceDesign.geometry.boundingBox.getSize(size);
          let min = element.SurfaceDesign.geometry.boundingBox.min;
          let max = element.SurfaceDesign.geometry.boundingBox.max;
          dimensions = size.x < size.y && size.x < size.z ? (size.x * 1000).toFixed(2): size.y < size.z ? (size.y * 1000).toFixed(2) : (size.z * 1000).toFixed(2);
          if(max.x - min.x > max.y - min.y)
          {
            dimensions =  Math.trunc(max.y - min.y) + " x " + element.thickness;
          }
          else{
            dimensions =  Math.trunc(element.Width) + " x " + element.thickness;
          }

          break;
        default:
          break;
      }
    }
    // else
    return {
      Id: element.properties?.General?.ElementId,
      General: ElementPropertiesMapper.MapGeneralProperties(element.properties, element.isExecuted, element.isDoubler, dimensions),
      Material: ElementPropertiesMapper.MapMaterialProperties(element),
      StructureAssessment: ElementPropertiesMapper.MapStructureAssessmentProperties(element.properties),
      // Regions Capacity group removed from the form (2026-09-29); kept for a possible future use.
      // RegionsCapacity: ElementPropertiesMapper.MapRegionsCapacityProperties(regionsData, sectionData),
      TypicalDetails: ElementPropertiesMapper.MapTypicalDetailsProperties(element.properties),
    }
    // }
  }

  private static MapGeneralProperties(data: any, executionStatus: boolean, doublerStatus: boolean, dimensions?: string): GeneralProperties {
    return {
      StructureType: data.TypeName,
      Dimensions_mm: dimensions,
      Label: this.GetName(data),
      Coating: data.General?.Coated ?? false,
      Executed: executionStatus,
      Doubler: doublerStatus
    }
  }

  private static GetName(data: any): string {
    switch (data.TypeName) {
      case 'Bracket':
        return data.General?.CompleteBracketLabel ?? data.General?.Label;
      case 'Stiffener':
        return data.General?.CompleteStiffenerLabel ?? data.General?.Label;
      default:
        return data.General?.Label;
    }
  }

  private static MapMaterialProperties(data: any): MaterialProperties {
    let material: MaterialProperties
    switch (data?.properties?.TypeName) {
      case 'Pipe':
        material = ElementPropertiesMapper.MapPipeMaterialProperties(data);
        break;
      default:
        material = ElementPropertiesMapper.MapGeneralMaterialProperties(data.MaterialType ?? data);
        break;
    }
    return material
  }

  private static MapGeneralMaterialProperties(data: MaterialType): MaterialProperties {
    return {
      Id: data?.Guid ?? "",
      Name: data?.Name ?? "",
      Grade: data?.materialSubType?.grade ?? "",
      Density_kgmm3: data?.materialSubType?.density ?? 0,
      YieldStrength_mpa: data?.materialSubType?.yieldStrength ?? 0,
      TensileStrength_mpa: data?.materialSubType?.tensileStrength ?? 0,
      YoungModulus_mpa: data?.materialSubType?.youngModulus ?? 0,
      ShearModulus_mpa: data?.materialSubType?.shearModulus ?? 0,
      PoissonRatio: data?.materialSubType?.poissonRatio ?? 0,
    }
  }

  private static MapPipeMaterialProperties(data: any): MaterialProperties {
    return {
      Id: data?.properties?.General?.MaterialId ?? "",
      Name: data?.Name ?? "",
      Grade: data?.materialSubType?.grade ?? "",
      Density_kgmm3: data?.materialSubType?.density ?? 0,
      YieldStrength_mpa: data?.materialSubType?.yieldStrength ?? 0,
      TensileStrength_mpa: data?.materialSubType?.tensileStrength ?? 0,
      YoungModulus_mpa: data?.materialSubType?.youngModulus ?? 0,
      ShearModulus_mpa: data?.materialSubType?.shearModulus ?? 0,
      PoissonRatio: data?.materialSubType?.poissonRatio ?? 0,
    }
  }

  private static MapStructureAssessmentProperties(data: any): StructureAssessmentProperties {
    let structureAssessment: StructureAssessmentProperties;
    switch (data.TypeName) {
      case 'Plate':
      case 'Solid':
        structureAssessment = ElementPropertiesMapper.MapPlateStructureAssessmentProperties(data);
        break;
      case 'FacePlate':
        structureAssessment = ElementPropertiesMapper.MapFacePlateStructureAssessmentProperties(data);
        break;
      case 'Bracket':
        structureAssessment = ElementPropertiesMapper.MapBracketStructureAssessmentProperties(data);
        break;
      case 'Stiffener':
        structureAssessment = ElementPropertiesMapper.MapStiffenerStructureAssessmentProperties(data);
        break;
      case 'BeamPart':
        switch (data.General?.PartGeometry?.Value) {
          case "Surface":
            structureAssessment = ElementPropertiesMapper.MapSurfaceBeamPartStructureAssessmentProperties(data);
            break;
          case "Solid":
            structureAssessment = ElementPropertiesMapper.MapSolidBeamPartStructureAssessmentProperties(data);
            break;
          default:
            structureAssessment = null;
            break;
        }
        break;
      case 'Cable':
        structureAssessment = ElementPropertiesMapper.MapCableStructureAssessmentProperties(data);
        break;
      case 'Pipe':
        structureAssessment = ElementPropertiesMapper.MapPipeStructureAssessmentProperties(data);
        break;
      default:
        structureAssessment = null;
        break;
    }
    return structureAssessment;
  }

  // public static MapDegradationProperties(data: any): DegradationProperties {
  //   let degradationProperties: DegradationProperties = ElementPropertiesMapper.MapPlateDegradationProperties(data);
  //   return degradationProperties;
  // }

  // private static MapPlateDegradationProperties(data: any): DegradationProperties {
  //   let wastageAllowance: number = (data.properties.Geometry?.WastageAllowance ?? 20);
  //   let substantialThickness = data.ruleThickness * (1 - 0.75 * (wastageAllowance / 100));
  //   substantialThickness = +substantialThickness;
  //   let ruleThickness = data.ruleThickness ?? 0.00;

  //   let substantialCorrosionThickness = data.AbsoluteDegradation == null ? '' : data.substantialCorrosionThickness.toFixed(2)
  //   let excessiveCorrosionThickness = data.AbsoluteDegradation == null ? '' : data.excessiveCorrosionThickness.toFixed(2)
  //   let averageThickness = data.properties?.Computed?.AverageThickness != 0.00 ? data.properties?.Computed?.AverageThickness : 0.00
  //   if (averageThickness == 0 && data.thicknessGaugingPoints.length == 0) {
  //     averageThickness = data.thickness
  //   }

  //   let absoluteDegradation = data.AbsoluteDegradation == null ? '' : data.AbsoluteDegradation.toFixed(2)
  //   let relativeDegradation = data.AbsoluteDegradation == null ? '' : ((data.AbsoluteDegradation / wastageAllowance) * 100).toFixed(2)
  //   let corrosionRate = data.CorrosionRate == null ? '' : data.CorrosionRate.toFixed(2)
  //   let remainingLife = !isNaN(data.RemainingLife) ? (data.RemainingLife > 0 ? data.RemainingLife.toFixed(2) : 0.00) : ''
  //   let estimatedThickness = data.AbsoluteDegradation == null ? '' : averageThickness.toFixed(2)
  //   let corrosionRiskIndex = data.CorrosionRiskIndex == null ? '' : data.CorrosionRiskIndex.toFixed(2)

  //   return {
  //     SubstantialCorrosionThickness_mm: substantialCorrosionThickness,
  //     ExcessiveCorrosionThickness_mm: excessiveCorrosionThickness,
  //     AbsoluteDegradation_percent: absoluteDegradation,
  //     RelativeDegradation_percent: relativeDegradation,
  //     CorrosionRate_mmyear: corrosionRate,
  //     RemainingLife_years: remainingLife,
  //     EstimatedThickness_mm: estimatedThickness,
  //     ReadingQuality: "",
  //     CorrosionRiskIndex: corrosionRiskIndex,
  //   }
  // }

  private static MapPlateStructureAssessmentProperties(data: any): PlateStructureAssessmentProperties {
    let wastageAllowance: number = (data.Geometry?.WastageAllowance ?? 20)?.toFixed(2);
    let substantialThickness = data.Geometry?.RuleThickness * (1 - 0.75 * (wastageAllowance / 100));
    substantialThickness = +substantialThickness?.toFixed(2);

    return {
      Campaign: data.General?.Collection?.Name ?? "",
      ReportDate: this.formatDateField(data.General?.Collection?.Date),
      WastageAllowance: wastageAllowance.toString() + "%",
      Thickness_mm: data.Geometry?.Thickness?.toFixed(2) ?? 0.00,
      RuleThickness_mm: data.Geometry?.RuleThickness?.toFixed(2) ?? 0.00,
      BaselineThickness_mm: data.Geometry?.BaselineThickness?.toFixed(2) ?? 0.00,
      SubstantialThickness_mm: substantialThickness,
      AverageThickness_mm:
        data.Computed?.AverageThickness?.toFixed(2) != 0.00 ? data.Computed?.AverageThickness?.toFixed(2) : 0.00,
      // data.Geometry?.Thickness?.toFixed(2) != 0.00 ? data.Geometry?.Thickness?.toFixed(2) : 0.00,
      Weight_kg: data.Computed?.Weight?.toFixed(2) ?? 0.00,
      Area_mm: data.Computed?.Area?.toFixed(1) ?? 0.00,
      Height_mm: data.Computed?.Height?.toFixed(1) ?? 0.00,
      Width_mm: data.Computed?.Width?.toFixed(1) ?? 0.00
    }
  }

  private static MapFacePlateStructureAssessmentProperties(data: any): FacePlateStructureAssessmentProperties {
    let wastageAllowance: number = (data.Geometry?.WastageAllowance ?? 20)?.toFixed(2);
    let substantialThickness = data.Geometry?.RuleThickness * (1 - 0.75 * (wastageAllowance / 100));
    substantialThickness = +substantialThickness?.toFixed(2);

    return {
      Campaign: data.General?.Collection?.Name ?? "",
      ReportDate: this.formatDateField(data.General?.Collection?.Date),
      WastageAllowance: (wastageAllowance).toString() + "%",
      Thickness_mm: data.Geometry?.Thickness?.toFixed(2) ?? 0.00,
      RuleThickness_mm: data.Geometry?.RuleThickness?.toFixed(2) ?? 0.00,
      BaselineThickness_mm: data.Geometry?.BaselineThickness?.toFixed(2) ?? 0.00,
      SubstantialThickness_mm: substantialThickness,
      AverageThickness_mm:
        data.Computed?.AverageThickness?.toFixed(2) != 0.00 ? data.Computed?.AverageThickness?.toFixed(2) : 0.00,
      // data.Geometry?.Thickness?.toFixed(2) != 0.00 ? data.Geometry?.Thickness?.toFixed(2) : 0.00,
    }
  }

  private static MapBracketStructureAssessmentProperties(data: any): BracketStructureAssessmentProperties {
    const wastageAllowance: number = (data.Geometry?.WastageAllowance ?? 20)?.toFixed(2);
    let webSubstantialThickness = data.Geometry?.RuleWebThickness * (1 - 0.75 * (wastageAllowance / 100));
    webSubstantialThickness = +webSubstantialThickness?.toFixed(2);
    let flangeSubstantialThickness = data.Geometry?.RuleFlangeThickness * (1 - 0.75 * (wastageAllowance / 100));
    flangeSubstantialThickness = +flangeSubstantialThickness?.toFixed(2);

    let webAverageThickness_mm = data.Computed?.AverageWebThickness?.toFixed(2) ?? 0.00;
    // if (webAverageThickness_mm == 0.00) {
    //   webAverageThickness_mm = data.Geometry?.WebThickness?.toFixed(2) ?? 0.00;
    // }

    let flangeAverageThickness_mm = data.Computed?.AverageFlangeThickness?.toFixed(2) ?? 0.00;
    // if (flangeAverageThickness_mm == 0.00) {
    //   flangeAverageThickness_mm = data.Geometry?.FlangeThickness?.toFixed(2) ?? 0.00;
    // }

    return {
      Campaign: data.General?.Collection?.Name ?? "",
      ReportDate: this.formatDateField(data.General?.Collection?.Date),
      WastageAllowance: wastageAllowance.toString() + "%",
      WebThickness_mm: data.Geometry?.WebThickness?.toFixed(2) ?? 0.00,
      WebRuleThickness_mm: data.Geometry?.RuleWebThickness?.toFixed(2) ?? 0.00,
      WebBaselineThickness_mm: data.Geometry?.WebBaselineThickness?.toFixed(2) ?? 0.00,
      WebSubstantialThickness_mm: webSubstantialThickness,
      WebAverageThickness_mm: webAverageThickness_mm,
      FlangeThickness_mm: data.Geometry?.FlangeThickness?.toFixed(2) ?? 0.00,
      FlangeRuleThickness_mm: data.Geometry?.RuleFlangeThickness?.toFixed(2) ?? 0.00,
      FlangeBaselineThickness_mm: data.Geometry?.FlangeBaselineThickness?.toFixed(2) ?? 0.00,
      FlangeSubstantialThickness_mm: flangeSubstantialThickness,
      FlangeAverageThickness_mm: flangeAverageThickness_mm
      // data.Computed?.FlangeAverageThickness?.toFixed(2) != 0.00 ? data.Computed?.FlangeAverageThickness?.toFixed(2) :
      // data.Geometry?.FlangeThickness?.toFixed(2) != 0.00 ? data.Geometry?.FlangeThickness?.toFixed(2) : 0,
    }
  }

  private static MapStiffenerStructureAssessmentProperties(data: any): StiffenerStructureAssessmentProperties {
    const wastageAllowance: number = (data.Geometry?.WastageAllowance ?? 20)?.toFixed(2);
    let webSubstantialThickness = data.Geometry?.RuleWebThickness * (1 - 0.75 * (wastageAllowance / 100));
    webSubstantialThickness = +webSubstantialThickness?.toFixed(2);
    let flangeSubstantialThickness = data.Geometry?.RuleFlangeThickness * (1 - 0.75 * (wastageAllowance / 100));
    flangeSubstantialThickness = +flangeSubstantialThickness?.toFixed(2);

    let webAverageThickness_mm = data.Computed?.AverageWebThickness?.toFixed(2) ?? 0.00;
    // if (webAverageThickness_mm == 0.00) {
    //   webAverageThickness_mm = data.Geometry?.WebThickness?.toFixed(2) ?? 0.00;
    // }

    let flangeAverageThickness_mm = data.Computed?.AverageFlangeThickness?.toFixed(2) ?? 0.00;
    // if (flangeAverageThickness_mm == 0.00) {
    //   flangeAverageThickness_mm = data.Geometry?.FlangeThickness?.toFixed(2) ?? 0.00;
    // }

    return {
      Campaign: data.General?.Collection?.Name ?? "",
      ReportDate: this.formatDateField(data.General?.Collection?.Date),
      WastageAllowance: wastageAllowance.toString() + "%",
      WebThickness_mm: data.Geometry?.WebThickness?.toFixed(2) ?? 0.00,
      WebRuleThickness_mm: data.Geometry?.RuleWebThickness?.toFixed(2) ?? 0.00,
      WebBaselineThickness_mm: data.Geometry?.WebBaselineThickness?.toFixed(2) ?? 0.00,
      WebSubstantialThickness_mm: webSubstantialThickness,
      WebAverageThickness_mm: webAverageThickness_mm,
      FlangeThickness_mm: data.Geometry?.FlangeThickness?.toFixed(2) ?? 0.00,
      FlangeRuleThickness_mm: data.Geometry?.RuleFlangeThickness?.toFixed(2) ?? 0.00,
      FlangeBaselineThickness_mm: data.Geometry?.FlangeBaselineThickness?.toFixed(2) ?? 0.00,
      FlangeSubstantialThickness_mm: flangeSubstantialThickness,
      FlangeAverageThickness_mm: flangeAverageThickness_mm
      // data.Computed?.FlangeAverageThickness?.toFixed(2) != 0.00 ? data.Computed?.FlangeAverageThickness?.toFixed(2)
      // data.Geometry?.FlangeThickness?.toFixed(2) != 0.00 ? data.Geometry?.FlangeThickness?.toFixed(2) : 0,
    }
  }

  private static MapSurfaceBeamPartStructureAssessmentProperties(data: any): SurfaceBeamPartStructureAssessmentProperties {
    let wastageAllowance: number = (data.Geometry?.WastageAllowance ?? 20)?.toFixed(2);
    let substantialThickness = data.Geometry?.RuleThickness * (1 - 0.75 * (wastageAllowance / 100));
    substantialThickness = +substantialThickness?.toFixed(2);

    return {
      Part: data.General?.Part?.Value,
      Campaign: data.General?.Collection?.Name ?? "",
      ReportDate: this.formatDateField(data.General.Collection.Date),
      WastageAllowance: wastageAllowance.toString() + "%",
      Thickness_mm: data.General?.Thickness?.toFixed(2) ?? 0.00,
      RuleThickness_mm: data.General?.RuleThickness?.toFixed(2) ?? 0.00,
      BaselineThickness_mm: data.General?.BaselineThickness?.toFixed(2) ?? 0.00,
      SubstantialThickness_mm: substantialThickness,
      AverageThickness_mm:
        data.Computed?.AverageThickness?.toFixed(2) != 0.00 ? data.Computed?.AverageThickness?.toFixed(2) : 0.00,
      // data.Geometry?.Thickness?.toFixed(2) != 0.00 ? data.Geometry?.Thickness?.toFixed(2) : 0.00,
      Weight_kg: data.Computed?.Weight?.toFixed(2) ?? 0.00
    }
  }

  private static MapSolidBeamPartStructureAssessmentProperties(data: any): SolidBeamPartStructureAssessmentProperties {
    let wastageAllowance: number = (data.Geometry?.WastageAllowance ?? 20)?.toFixed(2);
    let substantialThickness = data.Geometry?.Thickness * (1 - 0.75 * (wastageAllowance / 100));
    substantialThickness = +substantialThickness?.toFixed(2);

    return {
      Part: data.General?.Part?.Value,
      Campaign: data.General?.Collection?.Name ?? "",
      ReportDate: this.formatDateField(data.General.Collection.Date),
      WastageAllowance: wastageAllowance.toString() + "%",
      Weight_kg: data.Computed?.Weight?.toFixed(2) ?? 0.00
    }
  }

  private static MapCableStructureAssessmentProperties(data: any): CableStructureAssessmentProperties {
    let wastageAllowance: number = (data.Geometry?.WastageAllowance ?? 20)?.toFixed(2);
    let substantialThickness = data.Geometry?.Thickness * (1 - 0.75 * (wastageAllowance / 100));
    substantialThickness = +substantialThickness?.toFixed(2);

    return {
      Radius_mm: data.Geometry?.Radius.toFixed(2) ?? 0.00,
      Campaign: data.General?.Collection?.Name ?? "",
      ReportDate: this.formatDateField(data.General.Collection.Date),
      WastageAllowance: wastageAllowance.toString() + "%",
      Weight_kg: data.Computed?.Weight?.toFixed(2) ?? 0.00
    }
  }

  private static MapPipeStructureAssessmentProperties(data: any): PipeStructureAssessmentProperties {
    let thickness = data.Geometry?.Thickness ?? 0.00
    let ruleThickness = data.Geometry?.RuleThickness ?? thickness ?? 0.00
    let wastageAllowance: number = (data.Geometry?.WastageAllowance ?? data.Geometry?.AdmissiveCorrosion ?? 20)?.toFixed(2);
    let substantialThickness = ruleThickness * (1 - 0.75 * (wastageAllowance / 100));
    substantialThickness = +substantialThickness?.toFixed(2);

    let diameter = data?.Geometry?.Diameter ?? 0.00
    diameter = diameter / 25.4  // Convert Milimeters to Inch


    return {
      Campaign: data.General?.Collection?.Name ?? "",
      ReportDate: this.formatDateField(data.General?.Collection?.Date),
      NominalDiameter_inch: diameter.toFixed(2),
      WastageAllowance: wastageAllowance.toString() + "%",
      Thickness_mm: thickness.toFixed(2),
      RuleThickness_mm: ruleThickness.toFixed(2),
      SubstantialThickness_mm: substantialThickness,
      AverageThickness_mm:
        data.Computed?.AverageThickness?.toFixed(2) != 0.00 ? data.Computed?.AverageThickness?.toFixed(2) : 0.00,
      Schedule: data?.Geometry?.Schedule ?? "",
      Length_mm: data?.Geometry?.Length.toFixed(2) ?? 0.00
    }
  }

  // Regions Capacity mapping kept for a possible future use (group no longer rendered).
  // private static MapRegionsCapacityProperties(regionsData: any, sectionData: any): RegionCapacityProperties[] {
  //   return regionsData?.map(regionData => {
  //     return ElementPropertiesMapper.MapRegionCapacityProperties(regionData, sectionData)
  //   });
  // }

  // private static MapRegionCapacityProperties(regionData: any, sectionData: any): RegionCapacityProperties {
  //   return {
  //     Region: regionData?.General?.Description ?? regionData?.General?.TagService ?? "",
  //     Section: sectionData?.General?.Name ?? "",
  //     CargoType: regionData?.General?.Load ?? "",
  //     CargoDensity_tm3: 0.00,
  //     Temperature_celsius: 0.00
  //   }
  // }

  //Format date fields
  private static formatDateField(input: Date) {
    let formatedInput = ''
    if (input) {
      formatedInput = formatDate(input, "MM-dd-YYYY", "en-US")
    }
    return formatedInput
  }

  private static MapTypicalDetailsProperties(data: any): TypicalDetailsProperties {
    const typicalDetail = data?.TypicalDetail;
    if (!typicalDetail) {
      return null;
    }

    return {
      FamilyId: typicalDetail.FamilyId ?? "",
      IsFamilyModel: typicalDetail.IsFamilyModel ? "Yes" : "No",
      FamilyColor: typicalDetail.FamilyColor ?? "",
    }
  }
}

export class ElementPropertiesFormDataAssigner {

  private static normalizeGuid(value: any): string {
    return value?.toString().replace(/-/g, '').toLowerCase() ?? '';
  }

  private static assignMaterial(
    element: StructuralElement,
    materialId: string,
    materials: MaterialType[],
  ): void {
    const normalizedMaterialId = this.normalizeGuid(materialId);
    if (!normalizedMaterialId || !Array.isArray(materials)) {
      return;
    }

    const selectedMaterial = materials.find(material =>
      this.normalizeGuid(material?.Guid) === normalizedMaterialId
    );
    if (!selectedMaterial) {
      return;
    }

    element.properties.General.MaterialId = selectedMaterial.Guid;
    element.MaterialType = selectedMaterial;
    element.setComputedProperties(element.meanThicknessValue);
  }

  private static parseDecimal(value: any, fallback: any = 0): number {
    const parsedFallback = typeof fallback === 'number'
      ? fallback
      : Number(fallback?.toString().trim().replace(/%/g, '').replace(',', '.'));
    const fallbackValue = Number.isFinite(parsedFallback) ? parsedFallback : 0;

    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : fallbackValue;
    }

    if (value == null) {
      return fallbackValue;
    }

    const normalizedValue = value.toString().trim().replace(/%/g, '').replace(',', '.');
    if (normalizedValue === '') {
      return fallbackValue;
    }

    const parsedValue = Number(normalizedValue);
    return Number.isFinite(parsedValue) ? parsedValue : fallbackValue;
  }

  public static AssignData(
    element: StructuralElement,
    formData: ElementPropertiesVisualizationMode,
    materials: MaterialType[] = [],
  ): boolean {
    element.properties.General.Label = formData.General.Label;

    let updateGltfJson: boolean = false;
    if (element.properties.TypeName != formData.General.StructureType) {
      switch (formData.General.StructureType) {
        case 'Plate':
          element.TypeId = ElementTypeGuidEnum.PlateGuid;
          element.properties.TypeId = ElementTypeGuidEnum.PlateGuid;
          element.properties.TypeName = formData.General.StructureType;


          element.properties.Geometry.Thickness = element.properties.Geometry.WebThickness ? this.parseDecimal(element.properties.Geometry.WebThickness, element.properties.Geometry.Thickness) :
            element.properties.Geometry.FlangeThickness ? this.parseDecimal(element.properties.Geometry.FlangeThickness, element.properties.Geometry.Thickness) : element.properties.Geometry.Thickness;

          element.properties.Geometry.RuleThickness = element.properties.Geometry.RuleWebThickness ? this.parseDecimal(element.properties.Geometry.RuleWebThickness, element.properties.Geometry.RuleThickness) :
            element.properties.Geometry.RuleFlangeThickness ? this.parseDecimal(element.properties.Geometry.RuleFlangeThickness, element.properties.Geometry.RuleThickness) : element.properties.Geometry.RuleThickness;

          element.properties.Geometry.BaselineThickness = element.properties.Geometry.WebBaselineThickness ? this.parseDecimal(element.properties.Geometry.WebBaselineThickness, element.properties.Geometry.BaselineThickness) :
            element.properties.Geometry.FlangeBaselineThickness ? this.parseDecimal(element.properties.Geometry.FlangeBaselineThickness, element.properties.Geometry.BaselineThickness) : element.properties.Geometry.BaselineThickness;
          updateGltfJson = true;

          break;
        case 'FacePlate':
          element.TypeId = ElementTypeGuidEnum.FacePlateGuid;
          element.properties.TypeId = ElementTypeGuidEnum.FacePlateGuid;
          element.properties.TypeName = formData.General.StructureType;


          element.properties.Geometry.Thickness = element.properties.Geometry.WebThickness ? this.parseDecimal(element.properties.Geometry.WebThickness, element.properties.Geometry.Thickness) :
            element.properties.Geometry.FlangeThickness ? this.parseDecimal(element.properties.Geometry.FlangeThickness, element.properties.Geometry.Thickness) : element.properties.Geometry.Thickness;

          element.properties.Geometry.RuleThickness = element.properties.Geometry.RuleWebThickness ? this.parseDecimal(element.properties.Geometry.RuleWebThickness, element.properties.Geometry.RuleThickness) :
            element.properties.Geometry.RuleFlangeThickness ? this.parseDecimal(element.properties.Geometry.RuleFlangeThickness, element.properties.Geometry.RuleThickness) : element.properties.Geometry.RuleThickness;

          element.properties.Geometry.BaselineThickness = element.properties.Geometry.WebBaselineThickness ? this.parseDecimal(element.properties.Geometry.WebBaselineThickness, element.properties.Geometry.BaselineThickness) :
            element.properties.Geometry.FlangeBaselineThickness ? this.parseDecimal(element.properties.Geometry.FlangeBaselineThickness, element.properties.Geometry.BaselineThickness) : element.properties.Geometry.BaselineThickness;
          updateGltfJson = true;

          break;
        case 'Bracket':
          element.TypeId = ElementTypeGuidEnum.BracketGuid;
          element.properties.TypeId = ElementTypeGuidEnum.BracketGuid;
          element.properties.TypeName = formData.General.StructureType;

          element.properties.Geometry.WebThickness = element.properties.Geometry.Thickness ? this.parseDecimal(element.properties.Geometry.Thickness, element.properties.Geometry.WebThickness) :
            element.properties.Geometry.FlangeThickness ? this.parseDecimal(element.properties.Geometry.FlangeThickness, element.properties.Geometry.WebThickness) : element.properties.Geometry.WebThickness;

          element.properties.Geometry.RuleWebThickness = element.properties.Geometry.RuleThickness ? this.parseDecimal(element.properties.Geometry.RuleThickness, element.properties.Geometry.RuleWebThickness) :
            element.properties.Geometry.RuleFlangeThickness ? this.parseDecimal(element.properties.Geometry.RuleFlangeThickness, element.properties.Geometry.RuleWebThickness) : element.properties.Geometry.RuleWebThickness;

          element.properties.Geometry.WebBaselineThickness = element.properties.Geometry.BaselineThickness ? this.parseDecimal(element.properties.Geometry.BaselineThickness, element.properties.Geometry.WebBaselineThickness) :
            element.properties.Geometry.FlangeBaselineThickness ? this.parseDecimal(element.properties.Geometry.FlangeBaselineThickness, element.properties.Geometry.WebBaselineThickness) : element.properties.Geometry.WebBaselineThickness;
          updateGltfJson = true;

          break;
        case 'Stiffener':
          element.TypeId = ElementTypeGuidEnum.StiffenerGuid;
          element.properties.TypeId = ElementTypeGuidEnum.StiffenerGuid;
          element.properties.TypeName = formData.General.StructureType;

          element.properties.Geometry.WebThickness = element.properties.Geometry.Thickness ? this.parseDecimal(element.properties.Geometry.Thickness, element.properties.Geometry.WebThickness) :
            element.properties.Geometry.FlangeThickness ? this.parseDecimal(element.properties.Geometry.FlangeThickness, element.properties.Geometry.WebThickness) : element.properties.Geometry.WebThickness;

          element.properties.Geometry.RuleWebThickness = element.properties.Geometry.RuleThickness ? this.parseDecimal(element.properties.Geometry.RuleThickness, element.properties.Geometry.RuleWebThickness) :
            element.properties.Geometry.RuleFlangeThickness ? this.parseDecimal(element.properties.Geometry.RuleFlangeThickness, element.properties.Geometry.RuleWebThickness) : element.properties.Geometry.RuleWebThickness;

          element.properties.Geometry.WebBaselineThickness = element.properties.Geometry.BaselineThickness ? this.parseDecimal(element.properties.Geometry.BaselineThickness, element.properties.Geometry.WebBaselineThickness) :
            element.properties.Geometry.FlangeBaselineThickness ? this.parseDecimal(element.properties.Geometry.FlangeBaselineThickness, element.properties.Geometry.WebBaselineThickness) : element.properties.Geometry.WebBaselineThickness;
          updateGltfJson = true;

          break;
        default:
          break;
      }
    }
    else {
      updateGltfJson = false;
      if (element.isExecuted !== formData.General.Executed) {
        element.isExecuted = formData.General.Executed;
        element.materialBeforeFront = null;
      }
      switch (element.properties.TypeName) {
        case 'Plate':
          let plateData = (formData.StructureAssessment as PlateStructureAssessmentProperties);
          element.properties.Geometry.Thickness = this.parseDecimal(plateData.Thickness_mm, element.properties.Geometry.Thickness);
          element.properties.Geometry.RuleThickness = this.parseDecimal(plateData.RuleThickness_mm, element.properties.Geometry.RuleThickness);
          element.properties.Geometry.BaselineThickness = this.parseDecimal(plateData.BaselineThickness_mm, element.properties.Geometry.BaselineThickness);
          element.properties.Geometry.WastageAllowance = this.parseDecimal(plateData.WastageAllowance, element.properties.Geometry.WastageAllowance);
          element.admissibleCorrosion = element.properties.Geometry.WastageAllowance;
          break;
        case 'FacePlate':
          let facePlateData = (formData.StructureAssessment as FacePlateStructureAssessmentProperties);
          element.properties.Geometry.Thickness = this.parseDecimal(facePlateData.Thickness_mm, element.properties.Geometry.Thickness);
          element.properties.Geometry.RuleThickness = this.parseDecimal(facePlateData.RuleThickness_mm, element.properties.Geometry.RuleThickness);
          element.properties.Geometry.BaselineThickness = this.parseDecimal(facePlateData.BaselineThickness_mm, element.properties.Geometry.BaselineThickness);
          element.properties.Geometry.WastageAllowance = this.parseDecimal(facePlateData.WastageAllowance, element.properties.Geometry.WastageAllowance);
          element.admissibleCorrosion = element.properties.Geometry.WastageAllowance;
          break;
        case 'Bracket':
          let bracketData = (formData.StructureAssessment as BracketStructureAssessmentProperties);
          element.properties.Geometry.WebThickness = this.parseDecimal(bracketData.WebThickness_mm, element.properties.Geometry.WebThickness);
          element.properties.Geometry.RuleWebThickness = this.parseDecimal(bracketData.WebRuleThickness_mm, element.properties.Geometry.RuleWebThickness);
          element.properties.Geometry.WebBaselineThickness = this.parseDecimal(bracketData.WebBaselineThickness_mm, element.properties.Geometry.WebBaselineThickness);
          element.properties.Geometry.RuleFlangeThickness = this.parseDecimal(bracketData.FlangeRuleThickness_mm, element.properties.Geometry.RuleFlangeThickness);
          element.properties.Geometry.FlangeBaselineThickness = this.parseDecimal(bracketData.FlangeBaselineThickness_mm, element.properties.Geometry.FlangeBaselineThickness);
          element.properties.Geometry.WastageAllowance = this.parseDecimal(bracketData.WastageAllowance, element.properties.Geometry.WastageAllowance);
          element.admissibleCorrosion = element.properties.Geometry.WastageAllowance;
          break;
        case 'Stiffener':
          if (element.properties.Geometry.Thickness) {
            delete element.properties.Geometry.Thickness;
          }
          let stiffenerData = (formData.StructureAssessment as StiffenerStructureAssessmentProperties);
          element.properties.Geometry.WebThickness = this.parseDecimal(stiffenerData.WebThickness_mm, element.properties.Geometry.WebThickness);
          element.properties.Geometry.FlangeThickness = this.parseDecimal(stiffenerData.FlangeThickness_mm, element.properties.Geometry.FlangeThickness);
          element.properties.Geometry.RuleWebThickness = this.parseDecimal(stiffenerData.WebRuleThickness_mm, element.properties.Geometry.RuleWebThickness);
          element.properties.Geometry.WebBaselineThickness = this.parseDecimal(stiffenerData.WebBaselineThickness_mm, element.properties.Geometry.WebBaselineThickness);
          element.properties.Geometry.RuleFlangeThickness = this.parseDecimal(stiffenerData.FlangeRuleThickness_mm, element.properties.Geometry.RuleFlangeThickness);
          element.properties.Geometry.FlangeBaselineThickness = this.parseDecimal(stiffenerData.FlangeBaselineThickness_mm, element.properties.Geometry.FlangeBaselineThickness);
          element.properties.Geometry.WastageAllowance = this.parseDecimal(stiffenerData.WastageAllowance, element.properties.Geometry.WastageAllowance);
          element.admissibleCorrosion = element.properties.Geometry.WastageAllowance;
          break;
        default:
          break;
      }
    }

    this.assignMaterial(element, formData.Material?.Id, materials);

    return updateGltfJson;
  }
}
